module.exports = __webpack_public_path__ + "img/c8a47f496676aaac5334b98408107af9.png";